import { create } from "zustand";

/**
 * Store para gerenciar o estado do modal de erro
 */
const useErrorStore = create((set) => ({
  isOpen: false,
  title: "Erro",
  message: "",
  type: "error",
  onConfirm: null,
  confirmText: "Entendi",

  showError: (config) =>
    set({
      isOpen: true,
      title: config.title || "Erro",
      message: config.message || "Ocorreu um erro inesperado.",
      type: config.type || "error",
      onConfirm: config.onConfirm || null,
      confirmText: config.confirmText || "Entendi",
    }),

  closeError: () =>
    set({
      isOpen: false,
      onConfirm: null,
    }),

  reset: () =>
    set({
      isOpen: false,
      title: "Erro",
      message: "",
      type: "error",
      onConfirm: null,
      confirmText: "Entendi",
    }),
}));

export default useErrorStore;

/**
 * Helper function para mostrar erros de forma simples
 */
export const showError = (message, title = "Erro", type = "error") => {
  useErrorStore.getState().showError({ message, title, type });
};

/**
 * Helper function para mostrar erro de autenticação (401)
 */
export const showAuthError = (onConfirm) => {
  useErrorStore.getState().showError({
    title: "Sessão Expirada",
    message:
      "Sua sessão expirou. Você será redirecionado para a tela de login.",
    type: "warning",
    confirmText: "Fazer Login",
    onConfirm,
  });
};

/**
 * Helper function para mostrar avisos
 */
export const showWarning = (message, title = "Atenção") => {
  useErrorStore.getState().showError({ message, title, type: "warning" });
};

/**
 * Helper function para mostrar informações
 */
export const showInfo = (message, title = "Informação") => {
  useErrorStore.getState().showError({ message, title, type: "info" });
};
